import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=91d467bc&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=91d467bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d467bc",
  null
  
)

export default component.exports